/* eslint-disable import/prefer-default-export */
export const getSegmentLoaded = (state) => state.segmentLoaded;

export const getLoadSegment = (state) => state.loadSegment;

export const getSegmentLoadedSetter = (state) => state.setSegmentLoaded;

export const getLoadSegmentSetter = (state) => state.setLoadSegment;
